<template>
  <div>
  <!-- Questa vista serve solo come base per visualizzare il buono appaga   -->
  <ApPagaBuoni/>
  <!-- Avvia la pagina come appaga -->
  </div>
</template>

<script>

import ApPagaBuoni from '@/components/appaga/ApPagaBuoni'

export default {
  name: 'ApPaga',
  data () {
    return {}
  },
  components: {
    ApPagaBuoni
  }
}
</script>

<style scoped></style>